import { SensorTypeEnum } from "../enums/sensorType.enum";
import { TrackingTypeEnum } from "../enums/trackingType.enum";
import { ILookup } from "../shared/form/lookup.model";
import { Lookup } from "./lookup.model";
import { ParameterPercentage } from "./parameter.model";

export class Sensor implements ILookup {
  id: string;
  name: string;
}

export class SensorModel extends Sensor {
  configurationCapability: boolean;
  organizationLevelId: string;
  organizationLevelName: string;
  video_link: string;
  site: string;
  tracking: string;
  endpoint: string;
  activated: string;
  status: boolean;
  videoCapability: boolean;
  sensorType: SensorTypeEnum;
  trackingType: TrackingTypeEnum;
  batteryCharging: boolean;
  batteryPercentage: number;
  endPointId: string;
  endPointName: string;
  endPointIcon: string;
  parameterTypes?: [];
  installationDate: string | Date;
  lastUpdated: number;
  deactivationDate: number;
  gpsCapability: boolean;
  desiredOrientation?: string;
}

export class AssignmentDialogData {
  endPointId: string;
  endPointName: string;
  sensorId: string;
  sensorName: string;
  fromDate: Date;
  toDate: Date;
  parameters: ParameterPercentage[];
  organizationLevelId: string;
}

export class DeviceOverview {
  replacementCount: number;
  calibrationCount: number;
  videoCount: number;
  trackingTypes: { [key: string]: number };
  sensorTypes: { [key: string]: number };
}

export class SensorInfo {
  id?: string;
  name?: string;
  status: boolean;
  nextCalibration?: number;
  nextCalibrationFormatted?: string;
  imeI_No?: string;
  lastCalibrated?: number;
  lastCalibratedFormatted?: string;
  lastUpdated?: number;
  endPointId?: string;
  endPointName?: string;
  samplingFrequency?: number;
  firmware?: string; 
  installationDate?: number;
  installationDateFormatted?: string;
  batteryPercentage?: number;
  parameters: Lookup[]; 
}

export class FilterByModel {
  Condition: string;
  Field: string;
  Value: string;
}
